/**
 * AlertMsg — shows the app-wide toast for the Redux `showAlert(text)` action.
 *
 * The Redux side is unchanged (actions/generalActions.js showAlert sets
 * state.alert.{showAlert, alertText} and clears it after 4s). This component now
 * renders it with the new UI kit's toast (ui/feedback.js) instead of react-toastify.
 *
 * It fires once per alert (useEffect on the text/flag), so re-renders while an
 * alert is active no longer stack duplicate toasts.
 */
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { showToast } from '../../../ui/feedback';

const AlertMsg = ({ showAlert, alertText }) => {
  useEffect(() => {
    if (showAlert) showToast(alertText);
  }, [showAlert, alertText]);

  return null;
};

const mapStateToProps = (state) => ({
  showAlert: state.alert.showAlert,
  alertText: state.alert.alertText,
});

export default connect(mapStateToProps)(AlertMsg);
